import React from 'react';
import { isMobile } from 'react-device-detect';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

export const LendPoolHeader = () => {
    return (
        <>
            {!isMobile && (
                <div className='row mt-5' style={{ justifyContent: "center" }}>
                    <div className='col-lg-3 col-md-3 col-sm-3 text-center'>
                        <div>Pool</div>
                    </div>
                    <div className='col-lg-1 col-md-1 col-sm-1 d-flex justify-content-center'>
                        <div className='d-flex'>
                            <div>APY</div>
                            <Tooltip
                                placement="top"
                                title="Based on APY of the current underlying farming pools. It does not include fees from occasional rebalancing"
                            >
                                <InfoCircleOutlined className='h6 mx-1' style={{ marginTop: '1px', cursor: 'pointer' }} />
                            </Tooltip>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-3 col-sm-3 d-flex'>
                        <div className='col-lg-6 col-md-6 col-sm-6 text-center'>
                            <div>Total Supply</div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-6 text-center'>
                            <div>Total Borrowed</div>
                        </div>
                    </div>
                    <div className='col-lg-1 col-md-1 col-sm-1 text-center'>
                        <div>Utilization</div>
                    </div>
                    <div className='col-lg-2 col-md-2 col-sm-2 text-end'>
                        <div>Your Balance</div>
                    </div>
                    <div className='col-lg-2 col-md-2 col-sm-2'></div>
                </div>
            )}
        </>
    );
};
